import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ pollResponse, isMultipleChoice }) => {
  const mergedResponses = new Map();

  pollResponse.forEach((item) => {
    if (item.poll_option_id && (!item.archived || (item.archived && item.response_count > 0))) {
      if (mergedResponses.has(item.poll_option_id)) {
        mergedResponses.get(item.poll_option_id).response_count +=
          item.response_count || 0;
      } else {
        mergedResponses.set(item.poll_option_id, { ...item });
      }
    }
  });

  const filteredPollResponse = Array.from(mergedResponses.values());

  const labels = filteredPollResponse.map((item) => item.option_text);
  const responseCounts = filteredPollResponse.map((item) =>
    item.total_response ? item.total_response : item.response_count
  );

  // Calculate total responses
  const totalResponses = responseCounts.reduce((sum, count) => sum + count, 0);
  
  // Calculate percentages and round to nearest 10
  const percentages = responseCounts.map(count => {
    const percentage = (count / totalResponses) * 100;
    return Number(percentage.toFixed(2))
  });

  const urlRegex =
    /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

  const isUrlArray = labels?.every((item) => urlRegex.test(item));

  const processedLabels = isUrlArray ? labels.map(() => "GIF") : labels;

  const colors = ["#81A8FF", "#F4A15C", "#BDA6FF"];

  const data = {
    labels: processedLabels,
    datasets: [
      {
        data: percentages,
        backgroundColor: isMultipleChoice ? percentages.map((_, index) => colors[index % colors.length]) : colors[0],
        borderColor: isMultipleChoice ? percentages.map((_, index) => colors[index % colors.length]) : colors[0],
        borderWidth: 1,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        labels: {
          boxWidth: 0,
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.raw}%`;
          }
        }
      }
    },
    scales: {
      x: {
        border: {
          color: "#000",
          z: 2,
          width: 0,
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 10,
          precision: 0,
          callback: function(value) {
            return value + '%';
          }
        },
        border: {
          color: "#000",
          z: 3,
          width: 0,
        },
      },
    },
  };
  return <Bar data={data} options={options} />;
};

export default BarChart;
